//import * as React from 'react';

const toFetchIDValue = (item, dataValue) => {

    let returnID = "";
    let itemObject = {};

    let IDTYPE = {
        "SINGAPORE CITIZEN": "SP",
        "SINGAPORE PERMANENT RESIDENT": "SB",
        "FOREIGNER (PASSPORT)": "PP",

    }
    let countries = {
        "SINGAPORE": "SG",
        "MALAYSIA": "MY",
        "ANDORRA": "AD",
        "UNITED ARAB EMIRATES": "AE",
        "AFGHANISTAN": "AF",
        "ANTIGUA AND BARBUDA": "AG",
        "ANGUILLA": "AI",
        "ALBANIA": "AL",
        "ARMENIA": "AM",
        "NETHERLANDS ANTILLES": "AN",
        "ANGOLA": "AO",
        "ARGENTINA": "AR",
        "AMERICAN SAMOA": "AS",
        "AUSTRIA": "AT",
        "AUSTRALIA": "AU",
        "ARUBA": "AW",
        "AZERBAIJAN": "AZ",
        "BOSNIA-HERZEGOVINA": "BA",
        "BARBADOS": "BB",
        "BANGLADESH": "BD",
        "BELGIUM": "BE",
        "BURKINA FASO": "BF",
        "BULGARIA": "BG",
        "BAHRAIN": "BH",
        "BURUNDI": "BI",
        "BENIN": "BJ",
        "BERMUDA": "BM",
        "BRUNEI DARUSSALAM": "BN",
        "BOLIVIA": "BO",
        "BRAZIL": "BR",
        "BAHAMAS": "BS",
        "BHUTAN": "BT",
        "MYANMAR": "BU",
        "BOUVET ISLAND": "BV",
        "BOTSWANA": "BW",
        "BELARUS": "BY",
        "BELIZE": "BZ",
        "CANADA": "CA",
        "COCOS (KEELING) ISLANDS": "CC",
        "CENTRAL AFRICAN REP": "CF",
        "CONGO": "CG",
        "SWITZERLAND": "CH",
        "COTE D'IVOIRE (IVORY COAST)": "CI",
        "COOK IS": "CK",
        "CHILE": "CL",
        "CAMERON": "CM",
        "CHINA": "CN",
        "COLOMBIA": "CO",
        "COSTA RICA": "CR",
        "CUBA": "CU",
        "CAPE VERDE": "CV",
        "CHRISTMAS IS": "CX",
        "CYPRUS": "CY",
        "CZECH REPUBLIC": "CZ",
        "GERMANY": "DE",
        "DJIBOUTI": "DJ",
        "DENMARK": "DK",
        "DOMINICA": "DM",
        "DOMINICAN REPUBLIC": "DO",
        "ALGERIA": "DZ",
        "ECUADOR": "EC",
        "ESTONIA": "EE",
        "EGYPT": "EG",
        "WESTERN SAHARA": "EH",
        "SPAIN": "ES",
        "ETHIOPIA": "ET",
        "FINLAND": "FI",
        "FIJI": "FJ",
        "FALKLAND ISLANDS (MALVINAS)": "FK",
        "MICRONESIA, FEDERATED STATES OF": "FM",
        "FAROE ISLANDS": "FO",
        "FRANCE": "FR",
        "GABON": "GA",
        "UNITED KINGDOM": "GB",
        "GRENADA": "GD",
        "FRENCH GUIANA": "GF",
        "GUERNSEY": "GG",
        "GHANA": "GH",
        "GIBRALTAR": "GI",
        "GREENLAND": "GL",
        "GAMBIA": "GM",
        "GUINEA": "GN",
        "GUADELOUPE": "GP",
        "EQUATORIAL GUINEA": "GQ",
        "GREECE": "GR",
        "GUATEMALA": "GT",
        "GUAM": "GU",
        "GUINEA-BISSAU": "GW",
        "GUYANA": "GY",
        "HONGKONG": "HK",
        "HEARD AND MCDONALD ISLASNDS": "HM",
        "HONDURAS": "HN",
        "CROATIA": "HR",
        "HAITI": "HT",
        "HUNGARY": "HU",
        "INDONESIA": "ID",
        "IRELAND": "IE",
        "ISRAEL": "IL",
        "ISLE OF MAN": "IM",
        "INDIA": "IN",
        "BRITISH INDIAN OCEAN TERRITORY": "IO",
        "IRAQ": "IQ",
        "IRAN, ISLAMIC REPUBLIC OF": "IR",
        "ICELAND": "IS",
        "ITALY": "IT ",
        "JERSEY": "JE ",
        "JAMAICA": "JM ",
        "JORDAN": "JO ",
        "JAPAN": "JP ",
        "JERSEY": "JS ",
        "KENYA": "KE ",
        "KYRGYZSTAN": "KG ",
        "CAMBODIA": "KH ",
        "KIRIBATI": "KI ",
        "KAZAKHSTAN": "KK ",
        "COMOROS": "KM ",
        "SAINT KITTS-NEVIS": "KN ",
        "KOREA, DEMOCRATIC PEOPLE REPUBLIC OF (NORTH)": "KP ",
        "KOREA, REPUBLIC OF": "KR ",
        "KUWAIT": "KW ",
        "CAYMAN IS": "KY ",
        "LAO PEOPLE'S DEMOCRATIC REPUBLIC": "LA ",
        "LEBANON": "LB ",
        "SAINT LUCIA": "LC ",
        "LIECHSTENSTEIN": "LI ",
        "SRI LANKA": "LK ",
        "LIBERIA": "LR ",
        "LESOTHO": "LS ",
        "LITHUANIA": "LT ",
        "LUXEMBOURG": "LU ",
        "LATVIA": "LV ",
        "LIBYAN ARAB JAMAHIRIYA": "LY ",
        "MOROCCO": "MA ",
        "MONACO": "MC ",
        "MOLDOVA, REPUBLIC OF": "MD ",
        "MADAGASCAR": "MG ",
        "MARSHALL IS": "MH ",
        "MALI": "ML ",
        "MONGOLIA": "MN",
        "MACAO": "MO",
        "NORTHERN MARIANA IS": "MP",
        "MARTINIQUE": "MQ",
        "MAURITANIA": "MR",
        "MONTSERRAT": "MS",
        "MALTA": "MT",
        "MAURITIUS": "MU",
        "MALDIVES": "MV",
        "MALAWI": "MW",
        "MEXICO": "MX",

        "MOZAMBIQUE": "MZ",
        "NAMIBIA": "NA",
        "NEW CALEDONIA": "NC",
        "NIGER": "NE",
        "NORFOLK ISLAND": "NF",
        "NIGERIA": "NG",
        "NICARAGUA": "NI",
        "NETHERLANDS": "NL",
        "NORWAY": "NO",
        "NEPAL": "NP",
        "NAURU": "NR",
        "NIUE": "NU",
        "NEW ZEALAND": "NZ",
        "OMAN": "OM",
        "PANAMA": "PA",
        "PERU": "PE",
        "FRENCH POLYNESIA": "PF",
        "PAPUA NEW GUINEA": "PG",
        "PHILIPPINES": "PH",
        "PAKISTAN": "PK",
        "POLAND": "PL",
        "SAINT PIERRE AND MIQUELON": "PM",
        "PITCAIRN": "PN",
        "PUERTO RICO": "PR",
        "PALESTINIAN TERRITORY, OCCUPIED": "PS",
        "PORTUGAL": "PT",
        "PALAU": "PW",
        "PARAGUAY": "PY",
        "QATAR": "QA",
        "REUNION": "RE",
        "ROMANIA": "RO",
        "RUSSIAN FEDERATION": "RU",
        "RWANDA": "RW",
        "SAUDI ARABIA": "SA",
        "SOLOMAN IS": "SB",
        "SEYCHELLES": "SC",
        "SUDAN": "SD",
        "SWEDEN": "SE",

        "ST HELENA": "SH",
        "SLOVENIA": "SI",
        "SVALBARD AND JAN MAYEN IS": "SJ",
        "SLOVAKIA": "SK",
        "SIERRA LEONE": "SL",
        "SAN MARINO": "SM",
        "SENEGAL": "SN",
        "SOMALIA": "SO",
        "SURINAME": "SR",
        "SOUTH SUDAN": "SS",
        "SAO TOME AND PRINCIPE": "ST",
        "EL SALVADOR": "SV",
        "SYRIAN ARAB REPUBLIC (SYRIA)": "SY",
        "SWAZILAND": "SZ",
        "TURKS AND CAICOS IS": "TC",
        "CHAD": "TD",
        "FRENCH SOUTHERN TERRITORIES": "TF",
        "TOGO": "TG",
        "THAILAND": "TH",
        "TAJIKISTAN": "TJ",
        "TURKMENISTAN": "TM",
        "TUNISIA": "TN",
        "TONGA": "TO",
        "EAST TIMOR": "TP",
        "TURKEY": "TR",
        "TRINIDAD AND TOBAGO": "TT",
        "TUVALU": "TV",
        "TAIWAN, PROVINCE OF CHINA": "TW",
        "TANZANIA, UNITED REPUBLIC OF": "TZ",
        "UKRAINE": "UA",
        "UGANDA": "UG",
        "UNITED STATES MINOR OUTLYING ISLANDS": "UM",
        "UNITED STATES OF AMERICA": "US",
        "URUGUAY": "UY",
        "UZBEKISTAN": "UZ",
        "HOLY SEE (VATICAN CITY STATE)": "VA",
        "SAINT VINCENT AND THE GRENADINES": "VC",
        "VENEZUELA": "VE",
        "VIRGIN ISLANDS, BRITISH": "VG",
        "VIRGIN ISLANDS (US)": "VI",
        "VIET NAM": "VN",
        "VANUATU": "VU",
        "WALLIS AND FUTUNA": "WF",
        "SAMOA": "WS",
        "YEMEN PEOPLE'S DEMOCRATIC REPUBLIC": "YD",
        "YEMEN": "YE",
        "MAYOTTE": "YT",
        "YUGOSLAVIA": "YU",
        "SOUTH AFRICA": "ZA",
        "ZAMBIA": "ZM",
        "ZAIRE": "ZR",
        "ZIMBABWE": "ZW",
        "ALAND ISLANDS": "AX",
        "ANTARCTICA": "AQ",
        "ONGO, THE DEMOCRATIC REPUBLIC OF THE": "CD",
        "ERITREA": "ER",
        "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF": "MK",
        "MONTENEGRO": "ME",
        "SAINT BARTHÉLEMY": "BL",
        "SAINT MARTIN": "MF",
        "SERBIA": "RS",
        "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS": "GS",
        "TIMOR-LESTE": "TL",
        "GEORGIA": "GE",
        "KAZAKHSTAN": "KZ",
        "MYANMAR (BURMA)": "MM",
        "STATELESS": "ZZ",
        "CURACAO": "CW",
        "KOSOVO": "XK",
        "CARRIBBEAN NETHERLANDS": "BQ"



    }

    let BANKDATALIST = {
        "DBS": "7171",
        "CITIBANK NA": "7214",
        "Citibank Singapore Limited": "9201",
        "HSBC Bank (Singapore) Limited": "9548",
        "OCBC": "7339",
        "Standard Chartered Bank Singapore Limited": "9496",
        "UOB": "7375",
        "BANK OF CHINA LTD": "7083",
        "CIMB Bank Berhad": "7986",
        "GXS Bank Pte. Ltd.": "9751",
        "HL Bank": "7287",
        "Maribank Singapore Private Limited": "9779",
        "RHB Bank Berhad": "7366",
        "TRUST BANK SINGAPORE LIMITED": "9733"

    }
    switch (item.toUpperCase()) {
        case "IDTYPE":
            itemObject = IDTYPE;
            break;
        case "COUNTRIES":
            itemObject = countries;
            break;
        case "BANKDATALIST":
            itemObject = BANKDATALIST;
            break;

        default:
            break;
    }


    Object.keys(itemObject).map(function (key) {
        if (dataValue === key) {
            returnID = itemObject[key];
        }

    });
    return returnID;

}

export default toFetchIDValue